import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCompleted = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			opacity: .2,
			cx: 12,
			cy: 12,
			r: 12,
			fill: "#34C759"
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M15.8889 8.88886L10.8333 15.1111L7.72219 12",
				stroke: "#34C759",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 14,
				height: 14,
				fill: "white",
				transform: "translate(5 5)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgCompleted);
export default ForwardRef;
